import { Component } from "react";
import { Modal } from "semantic-ui-react";
import { Button, Paragraph } from "hireart-components";
import CandidateAvatar from "../../../../Managers/Hiring/components/Candidate/Avatar";

class GoogleCalendarDisconnectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      disconnectOpen: false,
      disconnecting: false,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      open: nextProps.open,
    };
  }

  showDisconnectModal = () => {
    this.props.onClose();
    this.setState({
      disconnectOpen: true,
    });
  };

  handleGoogleDisconnect = () => {
    this.setState({
      open: false,
      disconnectOpen: true,
      disconnecting: true,
    });
    document.location.href = "/managers/calendar/disconnect";
  };

  setOpen = (open) => this.setState({ open });

  setDisconnectOpen = (disconnectOpen) => this.setState({ disconnectOpen });

  render() {
    const { calendar } = this.props;
    return (
      <div>
        <Modal
          onClose={() => this.props.onClose()}
          open={this.state.open}
          closeOnDimmerClick={false}
          size="small"
        >
          <Modal.Header>Google Calendar sync</Modal.Header>
          <Modal.Content>
            <Paragraph
              size="small"
              text="Your HireArt calendar is synced with a Google account:"
            />
            <div
              style={{
                margin: "44px 100px",
                borderTop: "1px solid #DEDEDE",
                borderBottom: "1px solid #DEDEDE",
                padding: "15px 0",
              }}
            >
              <p style={{ lineHeight: "normal" }}>
                <span className="sync-profile-photo">
                  <CandidateAvatar
                    profile_picture_url={calendar.sync_profile_photo_url}
                    size={35}
                  />
                </span>
                <strong>{calendar.sync_profile_name}</strong>
                <br />
                <small style={{ color: "#717171" }}>
                  {calendar.sync_profile_email}
                </small>
              </p>
            </div>
            <Paragraph
              size="small"
              text="Your availability for HireArt interviews is updated automatically. Interviews you schedule through HireArt are added automatically to your Google Calendar."
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              label="Disconnect Google account"
              size="md"
              color="red"
              onClick={() => this.showDisconnectModal()}
            />
            <Button
              label="Close"
              size="md"
              onClick={() => this.props.onClose()}
            />
          </Modal.Actions>
        </Modal>
        <Modal
          onClose={() => this.setDisconnectOpen(false)}
          open={this.state.disconnectOpen}
          closeOnDimmerClick={false}
          size="small"
        >
          <Modal.Header>Disconnect Google Calendar</Modal.Header>
          <Modal.Content>
            <Paragraph
              size="small"
              text="Are you sure you want to disconnect this Google account from your HireArt calendar?"
            />
            <div
              style={{
                margin: "44px 100px",
                borderTop: "1px solid #DEDEDE",
                borderBottom: "1px solid #DEDEDE",
                padding: "15px 0",
              }}
            >
              <p style={{ lineHeight: "normal" }}>
                <span className="sync-profile-photo">
                  <CandidateAvatar
                    profile_picture_url={calendar.sync_profile_photo_url}
                    size={35}
                  />
                </span>
                <strong>{calendar.sync_profile_name}</strong>
                <br />
                <small style={{ color: "#717171" }}>
                  {calendar.sync_profile_email}
                </small>
              </p>
            </div>
            <Paragraph size="small">
              Once you disconnect,{" "}
              <strong>
                your availability for HireArt interviews will no longer be
                updated automatically
              </strong>
              . Interviews you schedule through HireArt will not be added
              automatically to your Google Calendar.
            </Paragraph>
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={this.state.disconnecting}
              label="Cancel"
              size="md"
              outlined
              onClick={() => this.setDisconnectOpen(false)}
            />
            <Button
              disabled={this.state.disconnecting}
              label={
                this.state.disconnecting === false
                  ? "Disconnect Google account"
                  : "Please wait..."
              }
              size="md"
              color="red"
              onClick={() => this.handleGoogleDisconnect()}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default GoogleCalendarDisconnectModal;
